"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SemanticCategory = void 0;
//REMINDER: Changes to this type must also be made in graphql/typesDefs.ts
var SemanticCategory;
(function (SemanticCategory) {
    SemanticCategory["type"] = "type";
    SemanticCategory["price"] = "price";
    SemanticCategory["ageGroup"] = "ageGroup";
    SemanticCategory["subject"] = "subject";
    SemanticCategory["tier"] = "tier";
    SemanticCategory["examBoard"] = "examBoard";
    SemanticCategory["owner"] = "owner";
})(SemanticCategory = exports.SemanticCategory || (exports.SemanticCategory = {}));
//# sourceMappingURL=SemanticCategory.js.map